export const Sources = {
  SITE: 'Site',
  TRACK: 'Track',
  LINE: 'Line',
  FIRST_PARTY: '1st-Party',
  GA4: 'GA4',
  LOCATION: 'Location',
  PROFILE: 'Profile',
  INTEREST: 'Interest',
  APP: 'APP',
  TAXONOMY: 'Taxonomy',
  INVOICE: 'Invoice',
  INVOICE_TAXONOMY: 'InvoiceTaxonomy'
}

export const SnapshotExtraSchemas = [
  {
    tableName: 'First_Party',
    columnName: 'm',
    type: 'STRING'
  },
  {
    tableName: 'First_Party',
    columnName: 'd',
    type: 'STRING'
  }
]
